import Dialog, {
  DialogHeader,
  DialogHeading,
} from '@raydiant/raydial/components/Dialog';
import Modal from '@raydiant/raydial/components/Modal';
import Button from '@raydiant/raydial/components/Button';
import Text from '@raydiant/raydial/components/Text';
import GetYourDeviceImg from './images/lets-get-started-1.svg';
import AddYourDeviceImg from './images/lets-get-started-2.svg';
import CreeateContentWithDisplaiAppsImg from './images/lets-get-started-3.svg';
import PublishToYourScreensImg from './images/lets-get-started-4.svg';
import { useUpdateOnboardingStatus } from '../../../../../hooks';

export interface LiteLocationOnboardingDialogProps {
  isOpen: boolean;
}

const LiteLocationOnboardingDialog = ({
  isOpen,
}: LiteLocationOnboardingDialogProps) => {
  const updateOnboardingStatus = useUpdateOnboardingStatus();

  const handleUpdateOnboardingStatus = async () => {
    try {
      await updateOnboardingStatus.mutate({ name: 'lite' });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal isOpen={isOpen} className="overflow-auto">
      <Dialog className="grid gap-4 relative">
        <div className="text-black">
          <DialogHeader>
            <DialogHeading>Let's Get Started</DialogHeading>
          </DialogHeader>
          <div className="flex flex-col pt-4 gap-8 md:pl-8 md:pr-28 ">
            <div className="flex items-center">
              <img src={GetYourDeviceImg} alt="get your device" />
              <div className="flex flex-col flex-1 ml-6 gap-1">
                <Text variant="smallSubheader">Get your device</Text>
                <Text className="text-gray-600" variant="body">
                  Purchase an Amazon Signage Stick
                </Text>
              </div>
            </div>
            <div className="flex items-center">
              <img src={AddYourDeviceImg} alt="add your device" />
              <div className="flex flex-col flex-1 ml-6 gap-1">
                <Text variant="smallSubheader">Add your device</Text>
                <Text className="text-gray-600" variant="body">
                  Add your device to the Screens page in Displai
                </Text>
              </div>
            </div>
            <div className="flex items-center">
              <img
                src={CreeateContentWithDisplaiAppsImg}
                alt="create content with Displai apps"
              />
              <div className="flex flex-col flex-1 ml-6 gap-1">
                <Text variant="smallSubheader">
                  Create content with Displai apps
                </Text>
                <Text className="text-gray-600" variant="body">
                  Create content, menus, and upload videos!
                </Text>
              </div>
            </div>
            <div className="flex items-center">
              <img
                src={PublishToYourScreensImg}
                alt="publish to your screens"
              />
              <div className="flex flex-col flex-1 ml-6 gap-1">
                <Text variant="smallSubheader">Publish to your screens</Text>
                <Text className="text-gray-600" variant="body">
                  Start displaying content on your screens
                </Text>
              </div>
            </div>
          </div>
          <footer className="flex flex-wrap gap-6 pb-4 px-4 mt-8">
            <Button
              size="large"
              variant="primary"
              className="grow"
              onPress={() => handleUpdateOnboardingStatus()}
            >
              Let's Go!
            </Button>
          </footer>
        </div>
      </Dialog>
    </Modal>
  );
};

export default LiteLocationOnboardingDialog;
